var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 17.9629C34 27.0088 26.6187 34.3527 17.5 34.3527C8.38133 34.3527 1 27.0088 1 17.9629C1 8.91712 8.38133 1.57324 17.5 1.57324C26.6187 1.57324 34 8.91712 34 17.9629Z",
    fill: "#141414",
    stroke: "#141414",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2262 16.228C24.5659 16.9966 24.5659 18.929 23.2262 19.6976L14.8078 24.5273C13.4744 25.2923 11.8125 24.3297 11.8125 22.7925L11.8125 13.133C11.8125 11.5958 13.4744 10.6333 14.8078 11.3982L23.2262 16.228Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.1d26f00c2343ad308c23b00910532567.svg";
export { ForwardRef as ReactComponent };